var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg057Mute(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.94 3.13996C15.3027 2.87103 14.5658 3.0176 14.08 3.50996L10.59 6.99996H8.40996L4.70996 3.28996C4.45631 3.03631 4.08659 2.93724 3.74009 3.03009C3.39358 3.12293 3.12293 3.39358 3.03009 3.74009C2.93724 4.08659 3.03631 4.45631 3.28996 4.70996L19.29 20.71C19.4777 20.8993 19.7333 21.0058 20 21.0058C20.2666 21.0058 20.5222 20.8993 20.71 20.71C20.8993 20.5222 21.0058 20.2666 21.0058 20C21.0058 19.7333 20.8993 19.4777 20.71 19.29L17 15.59V4.71996C17.002 4.02637 16.5825 3.40108 15.94 3.13996ZM15 13.59L10.41 8.99996H11C11.2658 9.0015 11.5212 8.89715 11.71 8.70996L15 5.40996V13.59ZM10.59 16H6.99996C5.34311 16 3.99996 14.6568 3.99996 13V8.99996C3.99996 8.44768 4.44768 7.99996 4.99996 7.99996C5.55225 7.99996 5.99996 8.44768 5.99996 8.99996V13C6.00107 13.2672 6.10911 13.5229 6.29996 13.71C6.48622 13.8947 6.73762 13.9989 6.99996 14H11C11.2672 14.0011 11.5229 14.1091 11.71 14.3L15.49 18.08C15.7771 18.3648 15.8645 18.7945 15.7112 19.1688C15.558 19.5431 15.1944 19.7883 14.79 19.79C14.5242 19.7915 14.2687 19.6872 14.08 19.5L10.59 16Z",
    fill: "#8199A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg057Mute);
export default __webpack_public_path__ + "static/media/057-mute.10258358ada28fd7f62415c3559709d2.svg";
export { ForwardRef as ReactComponent };